import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderGroupDTO  {
    _originalTypeClassName = "ekylikeio.BO.OrderGroupDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderGroupDTO.translate = translateService;
}
this.DateGroups = [];
this.TotalPrice = null;
this.OrderGroupDTOKey = null;
this._key = this.OrderGroupDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
TotalPrice:any;
Student:any;
DateGroups:any;
private _OrderGroupDTOKey:any;
get OrderGroupDTOKey(): any {
    return this._OrderGroupDTOKey;
  }
set OrderGroupDTOKey(value: any) {
    this._OrderGroupDTOKey = value;
    this._key = value;
  }
static setStudent = ($this, value) => {
var oldValue = $this.Student;
$this.Student = value;
if (value != null) {
}
}
static setDateGroups = ($this, items) => {
                if (items == null) items = [];
                if ($this.DateGroups == null) $this.DateGroups = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DateGroups.length > 0) {
                    Domain.OrderGroupDTO.removeDateGroups($this, $this.DateGroups[0]);
                }

                Domain.OrderGroupDTO.addManyDateGroups($this, copyItems);
            }
static addManyDateGroups = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrderGroupDTO.addDateGroups($this, items[i]);
                }
            }
static addDateGroups = ($this, item) => {
                if ($this.DateGroups == null) $this.DateGroups = [];
                if (item == null || $this.DateGroups.indexOf(item) > -1) return;
                $this.DateGroups.push(item);
}
static addRangeDateGroups = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrderGroupDTO.addDateGroups($this, item));
            }
static removeDateGroups = ($this, item) => {
                if ($this == null || $this.DateGroups == null || $this.DateGroups.indexOf(item) === -1) return;
                var _index = $this.DateGroups.indexOf(item);
                $this.DateGroups.splice(_index, 1);
}
static clearDateGroups = ($this) => { $this.DateGroups = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OrderGroupDTOKey == null || $this.OrderGroupDTOKey == 0;
            }


}